import { IS_LOCAL } from '../../config/env';

export const prepLogMessage = ({ msg, msgConfig }) => {
  const { id = '?', devData } = msgConfig;
  const msgPrefix = IS_LOCAL ? `[${id}] ` : '';
  const devDataStr = IS_LOCAL && devData ? ` ${JSON.stringify(devData)}` : '';
  return `${msg} ${msgPrefix} ${devDataStr}`;
};
